import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-7 pb-0 border-b" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import TabComponent from '@/components/TabComponent.vue';
import FormSection from '@/components/FormSection.vue';
import DetailSwitch from '@/components/inputs/DetailSwitch.vue';
import { ref, onMounted } from 'vue';
import RolePermissionService from '@/classes/RolePermissionService';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'PermissionPage',
  setup(__props) {

const route = useRoute();

const loader    = ref(false)
const showError = ref(false)
const errorMsg  = ref(null)

const roleId           = route.params.roleId as unknown as string;
const savedPermissions = ref({});
const permissionGroups = ref({});

const tabs: { name: string, count: number, href?: string, allowed: boolean }[] = [
    {
        name : 'Information',
        count: 0,
        href : `/accounts/roles/show/${roleId}`,
        allowed: true
    },
    {
        name : 'Permissions',
        count: 0,
        href : '',
        allowed: true
    },
];

const fetchPermissions = () => {
    loader.value = true;

    RolePermissionService.showPermissions(roleId)
        .then((result: any) => {
            loader.value           = false;
            savedPermissions.value = result.data.savedPermissions;
            permissionGroups.value = result.data.permissionGroups;
        })
        .catch((error: any) => {
            loader.value    = false;
            showError.value = true;
            errorMsg.value  = error.response.data.message;

            if(error.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

onMounted(() => { fetchPermissions() })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: "View Role",
    "show-back": "",
    backUrl: "/accounts/roles"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(TabComponent, { tabs: tabs })
      ]),
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permissionGroups.value, (permissionGroup, permissionGroupIndex) => {
          return (_openBlock(), _createBlock(FormSection, { key: permissionGroupIndex }, {
            title: _withCtx(() => [
              _createTextVNode(_toDisplayString(permissionGroup.module), 1)
            ]),
            description: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode(" Relevant data and other details ", -1)
            ]))]),
            form: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permissionGroup.permissions, (permission, permissionIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: permissionIndex,
                  class: "col-span-12"
                }, [
                  _createVNode(DetailSwitch, {
                    title: permission.label,
                    description: permission.description,
                    id: permission.name,
                    name: permission.name,
                    checked: savedPermissions.value[permission.id],
                    disabled: ""
                  }, null, 8, ["title", "description", "id", "name", "checked"])
                ]))
              }), 128))
            ]),
            _: 2
          }, 1024))
        }), 128))
      ])
    ]),
    _: 1
  }))
}
}

})